import AppHead from '@/components/AppHead';
import { Container } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
  },
  ptop: {
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(8),
    },
  },
}));

interface ContentProps {
  title?: string | null;
  disableGutters?: boolean;
  fixed?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  padtop?: boolean;
  children: React.ReactNode;
}

export default function Content({
  title = null,
  disableGutters = false,
  fixed = false,
  maxWidth = 'lg',
  padtop = false,
  children,
}: ContentProps): JSX.Element {
  const classes = useStyles();

  return (
    <Container
      className={clsx(classes.container, { [classes.ptop]: padtop })}
      disableGutters={disableGutters}
      fixed={fixed}
      maxWidth={maxWidth}
    >
      {!!title && <AppHead title={title} />}
      {children ?? <div />}
    </Container>
  );
}
